import React, { useState } from "react";
import './StepSelector.scss'
import { Modal } from "uxp/components";
import { IStepSelectorProps, StepType } from "@types";
import { CustomIconButton } from "@components/CustomIconButton/CustomIconButton";
import classNames from "classnames";
import { getRegisteredSteps } from "@utils";

export const StepSelector: React.FC<IStepSelectorProps> = (props) => {

    const { onSelect } = props

    const [show, setShow] = useState(false)

    function handleSelect(type: StepType) {
        onSelect(type)
        setShow(false)
    }

    return <div className='query-editor-step-selector-button-contianer'>
        <div className="query-editor-step-selector-button" onClick={() => { setShow(true) }} >-- Add step --</div>
        <Modal
            show={show}
            onClose={() => setShow(false)}
            className="query-editor-step-selector-modal"
        >
            <div className="query-editor-step-selector-modal-close-button">
                <CustomIconButton icon={['fas', 'times']} onClick={() => { setShow(false) }} />
            </div>
            <div className="query-editor-step-selector-available-step-types">

                {getRegisteredSteps()?.map((step: any, i: number) => {
                    return <div className="step-type-container"  key={i}>
                        <div className="step-type" onClick={() => handleSelect(step.type)}>
                            <div className="step-icon">
                                <div className={classNames("query-editor-step-type-ico-container")}>
                                    <div className="step-icon-contianer" style={{ ...step?.iconStyles, backgroundImage: `url(${step.icon})` }} ></div>
                                </div>
                            </div>
                            <div className="details">
                                <div className="name">{step.name}</div>
                                <div className="description">{step.description}</div>
                            </div>
                        </div>
                    </div>
                })}

            </div>
        </Modal>
    </div>
}